module.exports = __webpack_public_path__ + "img/@logo_lgcns@3x.0eeb59e1.png";